import React, { FC } from 'react';
import { CloseSiteFormProps } from './CloseSiteFormProps';
import LocationInfoFields from '../LocationInfoFields';
import SiteInfoFields from '../SiteInfoFields';

const CloseSiteForm: FC<CloseSiteFormProps> = ({
  countries,
  onCountryChange,
  BuList,
  isep,
  onBUChange,
  isEdit,
}) => {
  return (
    <>
      <LocationInfoFields
        countries={countries}
        buCode
        locationName
        buCodeRequired
        BUList={BuList}
        onCountryChange={onCountryChange}
        onBUChange={onBUChange}
        isep={isep}
        isEdit={isEdit}
      />
      <SiteInfoFields land unit unitType site transactionType />
    </>
  );
};

export default CloseSiteForm;
